import React, { createContext, useMemo, useState } from 'react';

const initialContext = {
  transparent: true,
  backgroundColor: null,
  antialias: false,
  autoDensity: false,
  sharedTicker: true,
  sharedLoader: true,
};

const getDevicePixelRatio = (d) => {
  if (window) {
    const dpi = window.devicePixelRatio;
    if (dpi > 0) return dpi;
  }
  return d;
};

const PixiContext = createContext(initialContext);

const PixiProvider = ({ children }) => {
  const [resolution, setResolution] = useState(getDevicePixelRatio(1));
  const value = useMemo(() => ({
    ...initialContext,
    resolution,
    setResolution,
  }), [resolution]);
  return <PixiContext.Provider value={value}>{children}</PixiContext.Provider>;
};

export { PixiContext, PixiProvider };
